<template>
  <div>
    <!-- <div style="position: fixed;top: 0;width: 100%; height: 100vh;object-fit: cover">
       <img style="height: 100%; object-fit: cover" src="../assets/backgrounds/promotion-background.jpg" alt="">
    </div> -->
    <!-- header start -->
    <header class="section-t-space">
      <div class="custom-container">
        <div class="header-panel">
          <router-link :to="{name: 'Main', query: {scr: this.$route.query.scr}}">
            <i class="ri-arrow-left-s-line"></i>
          </router-link>
          <h2>Food Categories</h2>
        </div>
      </div>
    </header>
    <!-- header end -->

    <!-- food section start -->
    <section class="categories section-lg-b-space">
      <div class="custom-container categorypage-wrapper">
        <div class="row gy-5 ratio_square">
          
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>
          <div v-if="loading" class="col-4">
              <CategoryPageLoaderVue />
          </div>

          <div class="col-4" v-for="ctg in category" :key="ctg.id">
            <router-link :to="{name: 'CategoryDetail', query: {id: ctg.id, scr: this.$route.query.scr}}">
              <div class="food-categories food">
                <img class="img-fluid categories-img" :src="getImageCategory(ctg.image)" alt="pizza" />
              </div>
              <h6 v-text="ctg.name"></h6>
            </router-link>
          </div>
        
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import CategoryPageLoaderVue from '@/components/loader/CategoryPageLoader.vue'

export default {
    namae: 'CategoryView',
    components:{
      CategoryPageLoaderVue
    },
    data(){
      return {
        category: [],
        loading: false,
        servers: '',
      }
    },
    mounted(){
        const decode = atob(this.$route.query.scr);
        const arrData = decode.split(";");
        this.servers = 'http://' + arrData[0] + '/api/web';

        this.loading = true;
        this.getValidate();
        axios.get( this.servers + '/cart/' + this.$route.query.scr)
        .then((res) => {
            if(res.data.is_submitted) this.$router.push({name: 'Submitted', query: {scr: this.$route.query.scr}});
        });
        this.getCategories()
    },
    methods: {
      async getValidate(){
          try {await axios.get(this.servers + '/home/' + this.$route.query.scr);} 
          catch(e){this.$router.push('/')}
      },
      async getCategories(){
        this.loading = true
        try {
          let { data } = await axios.get(this.servers + '/categories/' + this.$route.query.scr)
          this.category = data
          this.loading = false
        }catch(e){console.log(e.response.data)}
      },
      getImageCategory(filename){
        let name = String(filename).replace("JPG", "png");
        return '/assets/images/product/tamani/' + name;
      }
    }
}
</script>

<style>
.categorypage-wrapper{
  height: 100vh;
  background-image: url('../assets//backgrounds/tamani-chef.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right top;
  overflow: hidden;
}

.food-categories{
  border: 2.5px solid #603939;
  background-color: #efe1d3;
}
</style>